import { Beacon, UpdateActiveStep } from '@/components/forms/FormContext';
import { StepMap, steps } from '../../constants';

export const systemIssuesStepGraph: Beacon<StepMap> = {
	[steps.SystemIssues]: [steps.Picture],
};

export const handleNext: UpdateActiveStep = <StepMap>(): StepMap => {
	// What ever logic is needed to determine the next step
	return steps.Picture as StepMap;
};
